import apiClient from './apiClient';
import { API_ENDPOINTS } from './endpoints';

/**
 * Membership Service
 * Handles all membership-related API calls
 */
const membershipService = {
  getAllMemberships: async () => {
    const response = await apiClient.post(API_ENDPOINTS.MEMBERSHIP.GET_ALL);
    return response.data;
  },

  addMembership: async (data) => {
    const response = await apiClient.post(API_ENDPOINTS.MEMBERSHIP.ADD, data);
    return response.data;
  },

  updateMembership: async (data) => {
    const response = await apiClient.post(API_ENDPOINTS.MEMBERSHIP.UPDATE, data);
    return response.data;
  },

  deleteMembership: async (membershipId) => {
    const response = await apiClient.post(API_ENDPOINTS.MEMBERSHIP.DELETE, { membershipId });
    return response.data;
  },
};

export default membershipService;

